module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/seating-arrangement-create/seating-arrangement-create.component.scss
// module id = ./src/app/modules/backstage-module/common/seating-arrangement-create/seating-arrangement-create.component.scss
// module chunks = 9